import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item", "count", "empty", "query"]

  filter() {
    const query = this.inputTarget.value.toLowerCase().trim()
    let visible = 0

    this.itemTargets.forEach((item) => {
      const name = item.dataset.searchName || ""
      const match = !query || name.includes(query)
      item.classList.toggle("hidden", !match)
      if (match) visible++
    })

    if (this.hasCountTarget) {
      const noun = visible === 1 ? "recipe" : "recipes"
      const suffix = query ? ` matching '${this.inputTarget.value.trim()}'` : " in your cookbook"
      this.countTarget.textContent = `${visible} ${noun}${suffix}`
    }

    if (this.hasEmptyTarget) {
      const showEmpty = visible === 0 && query.length > 0
      this.emptyTarget.classList.toggle("hidden", !showEmpty)

      if (showEmpty && this.hasQueryTarget) {
        this.queryTarget.textContent = this.inputTarget.value.trim()
      }
    }
  }

  clear() {
    this.inputTarget.value = ""
    this.filter()
    this.inputTarget.focus()
  }
}
